export default {"src":"/_next/static/media/profile.8d178072.svg","height":20,"width":20};